import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'if',
  name: 'If',
  category: 'flow-control',
  description: 'Conditional branching based on conditions',
  icon: 'GitBranch',
  color: 'amber',
  version: '1.0.0',
  comingSoon: false,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'true',
      type: 'main',
      displayName: 'True',
    },
    {
      name: 'false',
      type: 'main',
      displayName: 'False',
    },
  ],
};

export default definition;
